import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Fetches data from the specified URL using Axios.
 * @param url - The URL to fetch data from.
 * @param config - Optional Axios request configuration.
 * @returns A Promise that resolves to the fetched data.
 * @throws An error if the request fails.
 */

const baseMyUrl = 'https://my.astin.io/api';

const sendFetch = async <T>(url: string, config?: AxiosRequestConfig, useBaseURL = false): Promise<[number, T]> => {
  try {
    const requestUrl = useBaseURL ? `${baseMyUrl}${url}` : url;
    const response: AxiosResponse<T> = await axios(requestUrl, config);
    console.log(response.status);
    return [response.status, response.data];
  } catch (error) {
    console.log(error);
    return [error.response.status, error.response.data];
  }
};

export default sendFetch;
